import { type GUID, type TimestampUTC } from '@common/types/brandedTypes';

export interface DebugSessionResponse {
  id: GUID;
  deviceId: number;
  createdUtc: string;
  isActive: boolean;
}

export enum DebugSessionOperationType {
  Wait = 1,
  Write = 2,
  Read = 3,
}

export interface CreateDebugSessionDetails {
  startUtc?: TimestampUTC;
  durationMaxSeconds: string;
  durationMaxCycles: string;
  operations: Array<
    & { registerIndex: string; }
    & ({
      type: DebugSessionOperationType.Write;
      value: string;
    } | {
      type: DebugSessionOperationType.Read;
      value?: never;
    })
  >;
}

export interface DebugSessionOperationResponse {
  id: GUID;
  type: DebugSessionOperationType;
  registerIndex?: number;
  value: number | null;
}

export interface DebugSessionRulesResponse {
  startUtc: TimestampUTC;
  durationMaxSeconds: number;
  durationMaxCycles: number;
  operations?: DebugSessionOperationResponse[];
}

export interface DebugSessionLogsResponse {
  createdUtc: string;
  context?: string;
  action?: string;
  value?: string;
}

export interface DebugSessionWithRulesResponse extends DebugSessionResponse {
  rules: DebugSessionRulesResponse;
  logs?: DebugSessionLogsResponse[];
}
